module.exports = [
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TempCases',
  },
  {
    __typename: 'WpPage_Pagebuilder_Layouts_TempFeaturesCta',
  },
]
